import { JSX } from 'react'

const PasswordResetReceivedNotification = (): JSX.Element => (
  <div>
    <strong>Request Received</strong> <br /> If we have an account using that email address <br />
    then an email will have been sent with instructions <br /> for how to reset your password
  </div>
)

export default PasswordResetReceivedNotification
